import React from 'react';
import { useSelector } from '@bridebook/web/lib/utils';
import LoadingSpinner from '@bridebook/web/components/common/loading-spinner/loading-spinner';
import { getShowFetchDraftModal } from '@bridebook/web/lib/weddings/selectors';

const FetchNewestDraftModal = React.lazy(() =>
  import('./fetch-newest-draft-modal').then((module) => ({
    default: module.FetchNewestDraftModal,
  })),
);

const FetchNewestDraftModalLazy = () => {
  const showFetchDraftModal = useSelector(getShowFetchDraftModal);
  if (!showFetchDraftModal) {
    return null;
  }

  return (
    <React.Suspense fallback={<LoadingSpinner />}>
      <FetchNewestDraftModal />
    </React.Suspense>
  );
};

export default FetchNewestDraftModalLazy;
